import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, Heading, Text, useResponsive } from '@common-fe/common-fe';

import { UseMyMoneyOption, UseMyMoneySummaryTitle } from '@/modules/UseMyMoney/UseMyMoney.types';
import AccountsDetailsContainer from '@/modules/UseMyMoney/widgets/AccountDetails/AccountDetails.container';

interface Props extends BoxExtendedProps {
  useMyMoneyOption?: string;
}

const ClaimSummaryHeader: React.FC<Props> = ({ useMyMoneyOption, ...props }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const description = useMemo(() => {
    if (useMyMoneyOption === UseMyMoneyOption.PAY_A_PROVIDER) {
      return t(
        'Review the details we pulled from your document, add any missing details, and choose your payment preferences before submitting.'
      );
    }
  }, [useMyMoneyOption, t]);

  return (
    <Box data-testId="claim-summary-header" {...props} style={{ alignSelf: 'stretch', ...props.style }}>
      {useMyMoneyOption && (
        <Box
          direction="row"
          align="center"
          style={{ width: '100%' }}
          data-testId="claim-summary-header_title"
        >
          <Heading
            size="regular"
            style={{
              maxWidth: isMobile ? '60%' : '100%',
              lineHeight: 1.2,
            }}
          >
            {t(UseMyMoneySummaryTitle?.[useMyMoneyOption as keyof typeof UseMyMoneySummaryTitle])}
          </Heading>

          {isMobile && (
            <Box style={{ flexShrink: 0 }}>
              <AccountsDetailsContainer isMobile />
            </Box>
          )}
        </Box>
      )}
      {description && !isMobile ? (
        <Text data-testId="claim-summary-header_description" margin={{ top: 'spacing2' }}>
          {description}
        </Text>
      ) : null}
    </Box>
  );
};

export default ClaimSummaryHeader;
